"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._ConvertWebflowSettings = exports._settings = exports.PRICEOVERVIEWID = void 0;
var cash_dom_1 = __importDefault(require("cash-dom"));
var input_output_helper_const_1 = require("./const/input-output-helper.const");
var input_mapping_const_1 = require("./const/input.mapping.const");
exports.PRICEOVERVIEWID = '#pricing-overview';
/**
 * @deprecated
 * workaround bcs settings service might not be initiated depending on when you have to call it
 */
exports._settings = typeof settings === 'object' ? settings : {};
var _ConvertWebflowSettings = function (finalSettings) {
    var _a, _b, _c, _d, _e;
    if (finalSettings) {
        finalSettings.averageCustomerDuration = 2.5;
        if (!((_a = finalSettings === null || finalSettings === void 0 ? void 0 : finalSettings.section) === null || _a === void 0 ? void 0 : _a.length)) {
            finalSettings.section = 'finish';
        }
        var tenantId = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.tenantId);
        if ((tenantId === null || tenantId === void 0 ? void 0 : tenantId.length) && !finalSettings.tenantKey) {
            finalSettings.tenantKey = tenantId;
        }
        finalSettings.environment = process.env.environment;
        finalSettings.prefillFromLocalStorage = (_b = finalSettings.prefillFromLocalStorage) !== null && _b !== void 0 ? _b : true;
        finalSettings.minimumAge = (_c = finalSettings === null || finalSettings === void 0 ? void 0 : finalSettings.minimumAge) !== null && _c !== void 0 ? _c : 18;
        finalSettings.matured = (_d = finalSettings === null || finalSettings === void 0 ? void 0 : finalSettings.matured) !== null && _d !== void 0 ? _d : 18;
        finalSettings.magicLineUrl = "https://".concat(finalSettings === null || finalSettings === void 0 ? void 0 : finalSettings.tenantKey, ".api.magicline.com");
        finalSettings.publicCloudFunction = location.href.includes('localhost')
            ? 'http://localhost:8081'
            : "https://".concat(finalSettings.environment === 'dev' ? 'dev-' : '', "magicline-public-endpoint-729907915433.europe-west3.run.app");
        finalSettings.athleticsUrl = "https://files.fittec.io/files/webflow/new-magicline/dev-php/athletics-api.php";
        finalSettings.agileaUrl = "https://agilea-public-endpoint-729907915433.europe-west3.run.app";
        finalSettings.assetsUrl = "https://files.fittec.io/files/webflow/new-magicline/".concat(finalSettings.environment === 'dev' ? 'dev' : '', "/assets");
        finalSettings.themisoftUrl = "https://".concat(finalSettings.environment === 'dev' ? 'dev-' : '', "themisoft-public-endpoint-729907915433.europe-west3.run.app");
        // finalSettings.yondUrl =
        //   finalSettings.environment === 'dev'
        //     ? `https://dev-yond-public-endpoint-729907915433.europe-west3.run.app`
        //     : `https://yond-public-endpoint-729907915433.europe-west3.run.app`;
    }
    //additional debug infos for dev environment;
    if (finalSettings.environment === 'dev') {
        if ((finalSettings === null || finalSettings === void 0 ? void 0 : finalSettings.minimumAge) > finalSettings.matured) {
            console.error('Note Minimum age ' + (finalSettings === null || finalSettings === void 0 ? void 0 : finalSettings.minimumAge) + '  is > than matured age ' + finalSettings.matured);
        }
        if (((_e = finalSettings === null || finalSettings === void 0 ? void 0 : finalSettings.startDate) === null || _e === void 0 ? void 0 : _e.length) &&
            !(finalSettings.startDate.includes('-') && typeof finalSettings.startDate === 'string')) {
            console.error('You provided a incorrect startdate in the tenant settings. Either remove it or check the format "YYYY-MM-DD" e.g. "2023-06-05"');
        }
        if (finalSettings && !(0, cash_dom_1.default)(exports.PRICEOVERVIEWID).length && (finalSettings === null || finalSettings === void 0 ? void 0 : finalSettings.section) === 'finish') {
            console.error('Price Overview id is not set: ' + exports.PRICEOVERVIEWID);
        }
    }
    return finalSettings;
};
exports._ConvertWebflowSettings = _ConvertWebflowSettings;
